import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { InmateAccountPayment } from '../models/InmateAccountPayment';
import { IAppState } from '../reducers';
import { audioVideoIndex } from '../resources/InmateAccountPayment';
import { IPaginatedResponse } from '../services/api';

export interface IAudioVideoHistoryLoadAction {
  type: typeof LOADING
  history: IPaginatedResponse<InmateAccountPayment>
}

export const LOADING = 'AUDIO_VIDEO_HISTORY/LOADING';
export const LOAD_SUCCESS = 'AUDIO_VIDEO_HISTORY/LOAD_SUCCESS';
export const LOAD_FAILURE = 'AUDIO_VIDEO_HISTORY/LOAD_FAILURE';
export function load(): ThunkAction<Promise<IPaginatedResponse<InmateAccountPayment>>, IAppState, undefined, Action> {
  return dispatch => {
    dispatch({ type: LOADING });

    return audioVideoIndex()
      .then((paginatedResponse): IPaginatedResponse<InmateAccountPayment> => {
        dispatch({ type: LOAD_SUCCESS, history: paginatedResponse });
        return paginatedResponse;
      })
      .catch(error => {
        dispatch({ type: LOAD_FAILURE, error });
        throw error;
      })
  }
}